const sanitiseString = (input: string): string =>
	input
		.toLowerCase()
		.replace(/[^a-z0-9\s]/g, '')
		.replace(/\s+/g, '-')
		.replace(/^-+|-+$/g, '');

export default sanitiseString;
